// extracted by mini-css-extract-plugin
export default {"inputNumber":"TrapImageInsectsVariationSettings_inputNumber__WBSv4","row":"TrapImageInsectsVariationSettings_row__SzNef"};